import {
  getSectionCopySettings,
  getSectionTypesList
} from '@/rest/sections'

import { sortBy } from 'lodash'

export default {
  state: () => ({
    availableCodes: [],
    numOfSectionsByCrewType: {},
    sectionTypes: [],
  }),
  getters: {
    getSectionTypes: state => {
      return sortBy(state.sectionTypes.filter(item => !item.disabled), item => item.orderNum)
    },
    getAllSectionTypes: state => {
      return sortBy(state.sectionTypes, item => item.orderNum)
    },
    getCrewTypes: state => {
      return Object.keys(state.numOfSectionsByCrewType)
    }
  },
  mutations: {
    setSections (state, payload) {
      state.sectionTypes = payload
    },
    setAvailableSectionTypeCodes (state) {
      state.availableCodes = state.sectionTypes.filter(item => !item.disabled).map(item => item.code)
    },
    setNumOfSectionsByCrewType (state, payload) {
      state.numOfSectionsByCrewType = payload
    }
  },
  actions: {
    async reload ({ commit }) {
      const sectionTypes = await getSectionTypesList()
      if (sectionTypes) {
        commit('setSections', sectionTypes)
        commit('setAvailableSectionTypeCodes')
      }
    },
    async getNumOfSectionsByCrewType ({ commit }) {
      const numOfSectionsByCrewType = await getSectionCopySettings()
      if (numOfSectionsByCrewType) {
        commit('setNumOfSectionsByCrewType', numOfSectionsByCrewType)
      }
    },
    async initialize ({ dispatch, rootGetters }) {
      if (!rootGetters.isAuthorized) {
        return
      }

      await dispatch('reload')
      await dispatch('getNumOfSectionsByCrewType')
      import.meta.env.DEV && console.log('initialized store – sectionTypes')
    }
  }
}
